<ngx-slider
  data-qa="test-price-range-slider"
  [(value)]="minValue"
  [(highValue)]="maxValue"
  [options]="options"
  (userChangeEnd)="onUserChangeEnd($event)"
  #slider
>
</ngx-slider>
<section *ngIf="showInputs; else noInputs" class="slider-inputs">
  <span>{{ getCurrencySymbol(selectedCurrency) }}</span>
  <rx-applications-input-number
    data-qa="test-price-range-min-input"
    #inputMinValue
    [hidePlusMinusIcons]="true"
    [ngModel]="minValue"
    class="input-padding"
    (ngModelChange)="changeMinValue($event)"
    (inputBlur)="onMinBlur($event, inputMinValue)"
    [allowEmpty]="true"
  ></rx-applications-input-number>
  <span> - </span>
  <rx-applications-input-number
    data-qa="test-price-range-max-input"
    #inputMaxValue
    [hidePlusMinusIcons]="true"
    [ngModel]="maxValue"
    class="input-padding"
    (ngModelChange)="changeMaxValue($event)"
    (inputBlur)="onMaxBlur($event, inputMaxValue)"
    [allowEmpty]="true"
  ></rx-applications-input-number>
</section>

<ng-template #noInputs>
  <span class="limit f-size-sm">
    {{ minValue | rxCurrency: selectedCurrency : 'symbol' : '1.0-0' }}
    -
    {{ maxValue | rxCurrency: selectedCurrency : 'symbol' : '1.0-0' }}</span
  >
</ng-template>
